































import { abolishOrder, checkOrderCost } from "@/api/order";
import { Vue, Prop, Component } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() orderId!: number;
  @Prop() orderNo!: number;
  form: any = {};
  dialogVisible: boolean = false;
  rules = {
    remark: [{ required: true, message: "请填写废除理由", trigger: "change" }],
  };
  openDialog() {
    checkOrderCost({
      order_id: this.orderId,
    }).then((res: any) => {
      // console.log(res.data.status);
      if (res.error_code === 0) {
        if (res.data.status === 1) {
          this.$alert(
            `订单中的课程已有点名签到记录或已结课，不能废除订单。`,
            `废除 - 订单${this.orderNo}`,
            {
              type: "warning",
              confirmButtonText: "关闭",
              confirmButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
              callback: (action) => {},
            }
          );
        } else if (res.data.status === 2) {
          this.$alert(
            `订单的课程在退课或转课中，暂不能废除。`,
            `废除 - 订单${this.orderNo}`,
            {
              type: "warning",
              confirmButtonText: "关闭",
              confirmButtonClass: "mwow-button-filled mini",
              iconClass: "mwow-icon-error",
              callback: (action) => {},
            }
          );
        } else {
          this.dialogVisible = true;
        }
      }
    });
  }
  handleClose() {
    this.dialogVisible = false;
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          abolishOrder({
            order_id: this.orderId,
            remark: this.form.remark,
          }).then((res: any) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "废除成功!",
              });
              this.handleClose();
              this.$emit("on-close");
            } else {
              this.$message({
                type: "error",
                message: "废除失败!" + res.message,
              });
            }
          });
        }
      }
    );
  }
}
